/** Version-bound public projection. No quotes, pricing policies or cumulative provider receipts. */
export interface MarketAnalysisUsage {
    schema_version: 'market-analysis-usage/v1';
    analysis_version: string;
    state: 'not_started' | 'settled' | 'pending' | 'unavailable';
    /** Exact display Work Units, not raw USD or subunits. Null is unknown, not zero. */
    confirmed_work_units: string | null;
}

export function validAnalysisUsage(value: unknown, version: unknown): value is MarketAnalysisUsage {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    const usage = value as Record<string, unknown>;
    if (Object.keys(usage).length !== 4 || usage.schema_version !== 'market-analysis-usage/v1'
        || typeof version !== 'string' || usage.analysis_version !== version) return false;
    const units = usage.confirmed_work_units;
    const positive = typeof units === 'string' && /^(0|[1-9]\d{0,13})(\.\d{1,5})?$/.test(units)
        && /[1-9]/.test(units);
    switch (usage.state) {
        case 'not_started': return units === '0';
        case 'settled': return positive;
        case 'pending': return units === null || positive;
        case 'unavailable': return units === null;
        default: return false;
    }
}
